import { useCallback, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Box, Flex } from '@brand/components';
import { locales } from 'locales/i18n';

import ComponentClientOnly from 'components/utils/ClientOnly';

const LocaleSwitcher = () => {
  const { i18n } = useTranslation();
  const [activeLng, setActiveLng] = useState(i18n.language);

  const handleChangeLanguage = useCallback(
    (lng: string) => {
      i18n.changeLanguage(lng);
      setActiveLng(lng);
    },
    [i18n],
  );

  return (
    <ComponentClientOnly>
      <Flex flexDirection="row" mb={[2, null, 0]} mt={[2, null, 0]}>
        {locales.map((locale, i) => {
          const isCurrent = locale.toLowerCase() === activeLng.toLowerCase();
          const isLast = i === locales.length - 1;
          return (
            <Box key={locale}>
              <Box
                as="button"
                color={activeLng === locale ? 'white' : 'placeholder'}
                fontWeight={isCurrent ? 'bold' : 'normal'}
                margin="0 8px"
                onClick={() => handleChangeLanguage(locale)}
                opacity={isCurrent ? 1 : 0.5}
              >
                {locale.toUpperCase()}
              </Box>
              <Box as="span" color="white" fontWeight="thin" opacity={0.5}>
                {!isLast && `|`}
              </Box>
            </Box>
          );
        })}
      </Flex>
    </ComponentClientOnly>
  );
};

export default LocaleSwitcher;
